<script setup>

</script>

<template>
  <div class="component-wrapper component-wrapper--off-shelf-wrapper">
    <div class="off-shelf-desc-text">
      车辆已售或不存在
    </div>
    <router-link
      :class="['navigator-to-index-button']"
      :to="{name: 'Index'}">
      返回首页
    </router-link>
  </div>
</template>

<style lang="scss" scoped>

.component-wrapper.component-wrapper--off-shelf-wrapper {
  margin: auto;
  text-align: center;
  padding: 30px 0;
  box-sizing: border-box;
}

.off-shelf-desc-text {
  font-size: 27px;
  opacity: 0.25;
  mix-blend-mode: multiply;
  filter: grayscale(90%);
}

.navigator-to-index-button {
  color: var(--blue-primary);
  font-size: 16px;
  margin-top: 10px;
  cursor: pointer;
}
</style>